import * as actionTypes from '../actions/actionTypes';

export const fetchInventorys = (data) => {
    return {
        type: actionTypes.FETCH_INVENTORYS,
        data
    }
}
export const createInventory = (data) => {
    return {
        type: actionTypes.CREATE_INVENTORY,
        data
    }
}
export const temporaryInventory = (data) => {
    return {
        type: actionTypes.TEMPORARY_INVENTORY,
        data
    }
}
export const clearTemporaryInventory = (data) => {
    return {
        type: actionTypes.CLEAR_TEMPORARY_INVENTORY,
    }
}
export const deleteInventory = (id) => {
    console.log(id);
    return {
        type: actionTypes.DELETE_INVENTORY,
        id
    }
}
export const updateInventory = (data) => {
    return {
        type: actionTypes.UPDATE_INVENTORY,
        data
    }
}
export const clearInventorys = () => {
    return {
        type: actionTypes.CLEAR_INVENTORYS
    }
}